import { URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import Notification from '../../handlers/Notification';
//import { b64toBlob } from './UtilsOperation';
import store from '../store';
import { DEFAULT_TIME_ZONE } from '../../constants/general';
import { FloatPrecision,regexGetNumber, localizedErrorHandler } from './UtilsOperation';

const getCoupons = (promo,sort,page = 1,search= null) => {
   return (dispatch,getState) => {
        const { company } = getState();
        return axios.get(`${URL}${company.id}/coupons?page=${page}&with=branchGroup&${promo?`type=promo`:`type=!=promo`}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}${search? `&name=ilike ${search}` :``}`).then( (res) => {//&sort_by=created_at,desc
            dispatch({
                type: 'FETCH_COUPONS',
                coupons: res.data
            })
        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });
        });
    }
}

const replaceCoupon = coupon => (dispatch, getState) => {
    let coupons = getState().coupons
    const found = coupons.findIndex(item => item.id === coupon.id)

    if (found >= 0) {
        coupons.splice(found, 1, coupon)
    }

    dispatch({
        type: 'FETCH_COUPONS',
        coupons: coupons
    })
}

const getCoupon = (couponId, isPromo) => {
   return (dispatch,getState) => {
        const { company } = getState();

        dispatch({type: "WAIT_FOR_RESPONSE"})//.branchGroup
        return axios.get(`${URL}${company.id}/coupons/${couponId}?with=couponTargets.related,branchGroup`).then( (res) => {

            let update = res.data
            if(update.total_count === 0){
               update.unlimited= true
            }
            if(update.config.max_discount_e2){
                update.config.max_discount_e2 = parseFloat(FloatPrecision(update.config.max_discount_e2/update.human_price_prc))
            }
            if(update.config.amount_limit_e2){
                update.config.amount_limit_e2 = parseFloat(FloatPrecision(update.config.amount_limit_e2 / 100));
            }
            if(isPromo){
                update.name = `Double - ${update.name}`;
            }
            dispatch({
                type: 'FETCH_COUPON',
                coupon: update
            })
        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });

        });
    }
}

const getCouponCodes = (couponId) => {
   return (dispatch,getState) => {
        let { coupon, company  } = getState();
        return axios.get(`${URL}${company.id}/coupons/${couponId}/codes`).then( (res) => {
            let update = {...coupon,
                available_codes:res.data.available_codes,
                used_codes:res.data.used_codes
            }
            dispatch({
                type: 'FETCH_COUPON',
                coupon:update
            })
        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });
        });
    }
}

const toggleData = (value, isType) => {
    return (dispatch,getState) => {
        var data = {
            ...getState().coupon,
        }
        if(isType){
            data.config.is_fixed = value.checked;
        }
        if( value.name === 'unlimited' ){
            data[value.name] = value.checked ;
            data.total_count = data.unlimited === true ? 0 : "";
        }else if(
            value.name === 'limit'
            || value.name === "purchase_condition_mode"
        ){
            data.config[value.name] = value.data;
            if(value.name === "purchase_condition_mode" && value.checked !== undefined ){
                data.config.min_purchase_count = value.checked ? 0 : null;
                data.config.max_purchase_count = null;
                data.config.last_purchase_min_days = null;
                data.config.last_purchase_max_days = null;
            }
        }else if(
            value.name === 'usable_in_promos'
            || value.name === 'only_deliveries'
            || value.name === 'avoid_same_target_promos'
            || value.name === 'is_cashback'
        ){
            data.config[value.name] = value.checked;
        }else if(
            value.name === 'limit'
            || value.name === 'company_assumption_prc'
            || value.name === 'users_registered_until'
            || value.name === 'users_registered_since'
            || value.name === 'max_discount_e2'
            || value.name === "collision_slot"
            || value.name === "amount_limit_e2"
            || value.name === "min_purchase_count"
            || value.name === "max_purchase_count"
            || value.name === "last_purchase_min_days"
            || value.name === "last_purchase_max_days"
        ){
            data.config[value.name] = value.data;
        }else if(value.name === 'purchase_mode'){
            if(value.data === 'custom' || value.data === ''){
                data.config.min_purchase_count = null;
                data.config.max_purchase_count = null;
            } else {
                let newData = value.data;
                if(newData.includes(":")){
                    newData = newData.split(":");
                    console.log("newData ====> ",newData)
                    data.config.min_purchase_count = newData[0] ? Number(newData[0]) : null;
                    data.config.max_purchase_count = newData[1] ? Number(newData[1]) : null;
                } else {
                    data.config.min_purchase_count = Number(newData);
                    data.config.max_purchase_count = null;
                }
            }
        }else if (value.name === "enable_purchase_days"){
           data.config.last_purchase_min_days = null;
           data.config.last_purchase_max_days = null;
        } else{
            if(value.data === 'base_price'){
                data.human_min_purchase_e2 = '0'
            }
            data[value.name] = value.data;
        }

        dispatch({
            type: 'FETCH_COUPON',
            coupon: data
        })
    }
}

export const clearCouponData = () => dispatch => {
    dispatch({
        type: 'CLEAR_COUPON_DATA',
    })
}

const createCoupon = (promo,double) => {
   return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        const { company } = getState();
        let { coupon, json_lang } = getState();

        let couponData = coupon;

        if(couponData.human_price_e2){
            couponData.human_price_e2=parseFloat(FloatPrecision(couponData.human_price_e2));
        }

        if(couponData.human_price_prc){
            couponData.human_price_prc=parseFloat(FloatPrecision(couponData.human_price_prc));
        }
        if(couponData.human_min_purchase_e2){
            couponData.human_min_purchase_e2=parseFloat(FloatPrecision(couponData.human_min_purchase_e2));
        }
        if(couponData.config.amount_limit_e2 === ""){
            couponData.config.amount_limit_e2 = null;
        } else if(couponData.config.amount_limit_e2){
            couponData.config.amount_limit_e2=parseFloat(FloatPrecision(couponData.config.amount_limit_e2 * 100));
        }
        if(couponData.config.max_discount_e2){
            couponData.config.max_discount_e2=parseFloat(FloatPrecision(FloatPrecision(couponData.config.max_discount_e2)*couponData.human_price_prc))
        }

        if(couponData.config.min_purchase_count === null){
            couponData.config.min_purchase_count = -1;
        }
        if(couponData.config.max_purchase_count === null){
            couponData.config.max_purchase_count = -1;
        }
        if(couponData.config.last_purchase_min_days === null){
            couponData.config.last_purchase_min_days = -1;
        }
        if(couponData.config.last_purchase_max_days === null){
            couponData.config.last_purchase_max_days = -1;
        }

        if(promo){
            couponData.type = `promo`
        }
        if(double){
            couponData.name=`Double - ${couponData.name}`;
        }

        return axios.post(`${URL}${company.id}/coupons`,couponData).then( (res) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({
                type: 'FETCH_COUPON',
                coupon: res.data
            })
            return res.data;
        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });
        });
    }
}
const copyCoupon = (promo,double) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let { coupon, json_lang, company } = getState();

        let couponData = coupon;

        if(couponData.human_price_e2){
            couponData.human_price_e2=parseFloat(FloatPrecision(couponData.human_price_e2));
        }

        if(couponData.human_price_prc){
            couponData.human_price_prc=parseFloat(FloatPrecision(couponData.human_price_prc));
        }
        if(couponData.human_min_purchase_e2){
            couponData.human_min_purchase_e2=parseFloat(FloatPrecision(couponData.human_min_purchase_e2));
        }
        if(couponData.config.max_discount_e2){
            couponData.config.max_discount_e2=parseFloat(FloatPrecision(FloatPrecision(couponData.config.max_discount_e2)*couponData.human_price_prc))
        }
        if(couponData.config.amount_limit_e2 === ""){
            couponData.config.amount_limit_e2 = null;
        } else if(couponData.config.amount_limit_e2){
            couponData.config.amount_limit_e2=parseFloat(FloatPrecision(couponData.config.amount_limit_e2 * 100));
        }

        if(couponData.config.min_purchase_count === null){
            couponData.config.min_purchase_count = -1;
        }
        if(couponData.config.max_purchase_count === null){
            couponData.config.max_purchase_count = -1;
        }
        if(couponData.config.last_purchase_min_days === null){
            couponData.config.last_purchase_min_days = -1;
        }
        if(couponData.config.last_purchase_max_days === null){
            couponData.config.last_purchase_max_days = -1;
        }

        if(promo){
            couponData.type = `promo`
        }
        if(double){
            couponData.name=`Double - ${couponData.name}`;
        }
        return axios.post(`${URL}${company.id}/coupons`,couponData).then( (res) => {
            let counter = 0;
            coupon.coupon_targets.forEach(target => {
                dispatch({type: "WAIT_FOR_RESPONSE"})
                return axios.put(`${URL}${company.id}/coupons/${res.data.id}/targets/${target.related_id}`).then( (res) => {
                }).catch((err) => {
                    counter=counter+1
                });
            })
            dispatch({type: "REMOVE_LOADING"})
            if(counter === 0){
                Notification.show({ type: "success", title:json_lang.common.success, msg:'El cupon fue duplicado con exito' });
            }else{
                Notification.show({type: "warning", title:`El cupon fue duplicado, ${counter} asociaciones fallon, favor verificar el cupon duplicado`});

            }
            return res.data;
         }).catch((err) => {
             Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });
         });
     }
 }

const deleteCoupon = (couponId) => {
   //Requiere: status!=running
   return (dispatch,getState) => {
        let { json_lang, company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(`${URL}${company.id}/coupons/${couponId}`).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({type: "REMOVE_LOADING"})
        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });
        });
    }
}

const editCoupon = (couponId) => {
   //Requiere: status=pending
   return (dispatch,getState) => {
        let { coupon, json_lang, company } = getState();
        let update={
            name:coupon.name,
            type:coupon.type,
            target_type:coupon.target_type,
            applies_to:coupon.applies_to,
            promo_code:coupon.promo_code,
            typeCoupon:coupon.typeCoupon,
            total_count:coupon.total_count,
            human_price_e2: coupon.human_price_e2,
            human_price_prc:coupon.human_price_prc,
            human_min_purchase_e2:coupon.human_min_purchase_e2 && coupon.human_min_purchase_e2 > 0 ? parseFloat(FloatPrecision(coupon.human_min_purchase_e2)):0,
            config:{
                limit:coupon.config.limit,
                is_cashback:coupon.config.is_cashback,
                is_fixed:coupon.config.is_fixed,
                collision_slot: coupon.config.collision_slot,
                min_purchase_count:coupon.config.min_purchase_count === null ? -1 : coupon.config.min_purchase_count,
                max_purchase_count:coupon.config.max_purchase_count === null ? -1 : coupon.config.max_purchase_count,
                last_purchase_min_days:coupon.config.last_purchase_min_days === null ? -1 : coupon.config.last_purchase_min_days,
                last_purchase_max_days:coupon.config.last_purchase_max_days === null ? -1 : coupon.config.last_purchase_max_days,
                purchase_condition_mode: coupon.config.purchase_condition_mode,
                max_discount_e2:coupon.config.max_discount_e2 && coupon.config.max_discount_e2 > 0 ? parseFloat(FloatPrecision(coupon.config.max_discount_e2)):"",
                amount_limit_e2:coupon.config.amount_limit_e2 === "" ? null : coupon.config.amount_limit_e2 && coupon.config.amount_limit_e2 > 0 ? parseFloat(FloatPrecision(coupon.config.amount_limit_e2 * 100)):null,
            }
        }
        if(coupon.human_price_e2 && coupon.human_price_e2 > 0){
            update.human_price_e2=parseFloat(FloatPrecision(coupon.human_price_e2))
        }

        if(coupon.human_price_prc && coupon.human_price_prc > 0){
            update.human_price_prc=parseFloat(FloatPrecision(coupon.human_price_prc))
        }
        if(coupon.config.max_discount_e2){
            update.config.max_discount_e2=parseFloat(FloatPrecision(FloatPrecision(update.config.max_discount_e2)*update.human_price_prc))
        }

        if(coupon.type === 'batch' && coupon.config && coupon.config.limit){
            update.config={
                ...update.config,
                limit:parseInt(coupon.config.limit,10)
            }
        }

        if(
            coupon.config && (coupon.config.company_assumption_prc)
        ){
            update.config={
                ...update.config,
                company_assumption_prc:coupon.config.company_assumption_prc
            }
        }
        if(
            coupon.config && (coupon.config.usable_in_promos || coupon.config.usable_in_promos === false)
        ){
            update.config={
                ...update.config,
                usable_in_promos:coupon.config.usable_in_promos
            }
        }
        if(
            coupon.config && (coupon.config.only_deliveries || coupon.config.only_deliveries === false)
        ){
            update.config={
                ...update.config,
                only_deliveries:coupon.config.only_deliveries
            }
        }

        if(
            coupon.config && (coupon.config.only_first_purchase || coupon.config.only_first_purchase === false)
        ){
            update.config={
                ...update.config,
                only_first_purchase:coupon.config.only_first_purchase
            }
        }

        if(
            coupon.config && (coupon.config.users_registered_since || coupon.config.users_registered_since === false)
        ){
            update.config={
                ...update.config,
                users_registered_since:coupon.config.users_registered_since
            }
        }

        if(
            coupon.config && (coupon.config.users_registered_until || coupon.config.users_registered_until === false)
        ){
            update.config={
                ...update.config,
                users_registered_until:coupon.config.users_registered_until
            }
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL}${company.id}/coupons/${couponId}`,update).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({type: "REMOVE_LOADING"})
            return res.data;
        }).catch((err) => {
            Notification.show({type:"error" , title:err.title, msg:err.data.description });
        });
    }
}
const editCouponEndDate = (couponId) => {
   return (dispatch,getState) => {
        let { coupon, json_lang, company } = getState();
        let update={
           ends_at: coupon.ends_at
        }
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.patch(`${URL}${company.id}/coupons/${couponId}/update-running`,update).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({type: "REMOVE_LOADING"});
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            Notification.show({type:"error" , title:err.title, msg:err.data.description });
        });
    }
}

const attachCoupon = (couponId,targetId,target_type) => {
   //Requiere: status=pending
   return (dispatch,getState) => {
        let { coupon, json_lang,branchGroups,goodsList, company } = getState();
        let target;
        if(target_type === "branch_group" || target_type === "good" || target_type === "city"){
            target= targetId
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.put(`${URL}${company.id}/coupons/${couponId}/targets/${targetId.id}`).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({type: "REMOVE_LOADING"})
            let newcupon = res.data

            if(target_type === "branch_group" || target_type === "good" || target_type === "city"){
                newcupon.related ={
                    id:target.id,
                    name:target.name
                }
            }

            let newtarget = coupon.coupon_targets.concat(newcupon)
            let update = coupon
            update.coupon_targets =newtarget

            dispatch({
                type: 'FETCH_COUPON',
                coupon: update
            })
        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });
        });
    }
}

const unattachCoupon = (couponId,targetId) => {
   //Requiere: status=pending
   return (dispatch,getState) => {
        let { json_lang,coupon, company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(`${URL}${company.id}/coupons/${couponId}/targets/${targetId}`).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({type: "REMOVE_LOADING"})
            let find = coupon.coupon_targets.filter( (coupon_target) => { return ( coupon_target.related_id !== targetId ) })
            let update = coupon
            update.coupon_targets = find

            dispatch({
                type: 'FETCH_COUPON',
                coupon: {...update}
            })
        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });
        });
    }
}

const setBlacklist = (couponId, list) => {
    //Requiere: status=pending
    return (dispatch,getState) => {
        let { coupon, json_lang, company } = getState();
        let newBlackList = [];
        if(list){
            newBlackList = [
                ...coupon.config.target_blacklist,
                list
            ]
        }

        let update = {
            config: {
                target_blacklist: newBlackList
            }
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL}${company.id}/coupons/${couponId}`,update).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({
                type: 'FETCH_COUPON',
                coupon: {
                    ...coupon,
                    ...res.data
                }
            })
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({type:"error" , title:err.title, msg:err.data.description });
        });
     }
 }

const unSetBlacklist = (couponId, list) => {
    //Requiere: status=pending
    return (dispatch,getState) => {
        let { coupon, json_lang, company } = getState();
        const newBlackList = [
            ...coupon.config.target_blacklist.filter((item) => item !== list)
        ]
        let update = {
            config: {
                target_blacklist: newBlackList
            }
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL}${company.id}/coupons/${couponId}`,update).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({
                type: 'FETCH_COUPON',
                coupon: {
                    ...coupon,
                    ...res.data
                }
            })
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({type:"error" , title:err.title, msg:err.data.description });
        });
     }
 }

const setWhiteList = (couponId, list) => {
    //Requiere: status=pending
    return (dispatch,getState) => {
        let { coupon, json_lang, company } = getState();
        let newWhiteList = null;
        
        if(list){
            if(coupon.whitelist){
                newWhiteList = [
                    ...coupon.whitelist,
                    list
                ]
            } else {
                newWhiteList = [list]
            }
        }

        let update = {
            whitelist: newWhiteList
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL}${company.id}/coupons/${couponId}`,update).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({
                type: 'FETCH_COUPON',
                coupon: {
                    ...coupon,
                    ...res.data
                }
            })
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({type:"error" , title:err.title, msg:err.data.description });
        });
     }
 }

const unSetWhiteList = (couponId, list) => {
    //Requiere: status=pending
    return (dispatch,getState) => {
        let { coupon, json_lang, company } = getState();
        const newWhiteList = [
            ...coupon.whitelist.filter((item) => item !== list)
        ]
        let update = {
            whitelist: newWhiteList.length > 0 ? newWhiteList : null
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL}${company.id}/coupons/${couponId}`,update).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({
                type: 'FETCH_COUPON',
                coupon: {
                    ...coupon,
                    ...res.data
                }
            })
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({type:"error" , title:err.title, msg:err.data.description });
        });
     }
 }
         
const changeCouponTargetType = (couponId, targetType) => {
    return (dispatch,getState) => {
        let { coupon, json_lang, company } = getState();
        let update = {
            target_type: targetType,
            config: {
                target_blacklist: coupon.target_type !== targetType ? [] : coupon.config.target_blacklist
            }
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL}${company.id}/coupons/${couponId}`,update).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({
                type: 'FETCH_COUPON',
                coupon: {
                    ...coupon,
                    ...res.data
                }
            })
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({type:"error" , title:err.title, msg:err.data.description });
        });
     }
 }

const setReadyCoupon = (couponId) => {
   //Requiere: status=pending
   return (dispatch,getState) => {
        let { coupon, json_lang,company,coupons } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        coupon.timezone = company.time_zone_offset ? company.time_zone_offset : DEFAULT_TIME_ZONE
        return axios.post(`${URL}${company.id}/coupons/${couponId}/set-ready`,coupon).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({type: "REMOVE_LOADING"})
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                switch(error.code){
                    case "EF314":
                        let match= regexGetNumber(error.message);
                        setTimeout(() => {
                            let couponName = coupon.name;
                            let conflictCouponName = coupons && coupons.data.find((coupon) => coupon.id === match[1]);
                            if(conflictCouponName){
                                Notification.show({
                                    type: "error", 
                                    title:`Sin activar: ${couponName}`, 
                                    msg: `No puede estar corriendo al mismo tiempo que: ${conflictCouponName.name}` 
                                });
                            } else {
                                return axios.get(`${URL}${company.id}/coupons/${match[1]}`)
                                .then((res) => {
                                    Notification.show({
                                        type: "error", 
                                        title:`Sin activar: ${couponName}`, 
                                        msg: `No puede estar corriendo al mismo tiempo que: ${res.data.name}` 
                                    });
                                })
                                .catch(() => {
                                    Notification.show({type: "error", title:`Error`, msg: json_lang.two_steps_modal.default_error });
                                })
                                
                            }
                        }, 1);
                        break;
                    default:
                        Notification.show({
                            type: "error",
                            title:`Error ${error.code}`,
                            msg: `${error.message}` 
                        });
                        break;
                }
            } else {
                Notification.show({type: "error", title:`Error`, msg: json_lang.two_steps_modal.default_error });
            }

        });
    }
}

const setFinishedCoupon = (couponId) => {
   //Requiere: status=pending
   return (dispatch,getState) => {
        let { coupon, json_lang, company } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL}${company.id}/coupons/${couponId}/set-finished`,coupon).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({type: "REMOVE_LOADING"})
        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.title });
        });
    }
}

const clearCoupon  = () => {
    return (dispatch) => {
        let coupon={
            name:"",
            type:"",
            promo_code:"",
            human_price_prc:"",
            human_price_e2:"",
            applies_to:"",
            total_count:"",
            unlimited:false,
            config :{
                limit:""
            }
        }
        dispatch({
            type: 'FETCH_COUPON',
            coupon: coupon
        })
    }
}

export {
    setFinishedCoupon,
    setReadyCoupon,
    attachCoupon,
    editCoupon,
    editCouponEndDate,
    toggleData,
    getCoupons,
    getCoupon,
    createCoupon,
    copyCoupon,
    clearCoupon,
    deleteCoupon,
    unattachCoupon,
    getCouponCodes,
    replaceCoupon,
    setBlacklist,
    setWhiteList,
    unSetBlacklist,
    unSetWhiteList,
    changeCouponTargetType
};



// WEBPACK FOOTER //
// ./src/store/actions/couponsActions.js